export class SimpleValidate {
    static instances = new Map<string, SimpleValidate>();

    el: HTMLFormElement;
    invalidElements: HTMLInputElement[] = [];
    
    private constructor(triggerElement: HTMLFormElement) {
        this.el = triggerElement;

        this.el.querySelectorAll<HTMLInputElement>('input, select, textarea').forEach(item => {
            item.addEventListener('blur', () => this.validateElement(item, false))
        })

        this.el.querySelectorAll<HTMLElement>('[simple-validate-check]').forEach(item => {
            item.addEventListener('click', (event) => {
                if (!this.validate()) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            })
        })
    }

    static getInstance(triggerElement: HTMLFormElement): SimpleValidate {
        const modalId = triggerElement.getAttribute('id') ?? 'simple-validate-form-1';
        let instance = SimpleValidate.instances.get(modalId);

        if (!instance) {
            instance = new SimpleValidate(triggerElement);
            SimpleValidate.instances.set(modalId, instance);
        }

        return instance;
    }

    validate() {
        let isValid: boolean = true
        let firstError: HTMLElement | null = null

        this.el.querySelectorAll<HTMLInputElement>('input, select, textarea').forEach(f => {
            if (f.disabled != true && this.validateElement(f, firstError == null) == false) {
                firstError = f
                isValid = false
            }
        })
        
        return isValid
    }

    validateElement(itemToValidate: HTMLInputElement, scrollToError: boolean) {
        if (this.checkVisibility(itemToValidate) == true) {
            
            if (itemToValidate.checkValidity() == false) {
                itemToValidate.classList.add('error')

                if (scrollToError) {
                    itemToValidate.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
                }

                this.invalidElements.push(itemToValidate)

                return false
            }
            else {
                itemToValidate.classList.remove('error')
            }
        }

        return true
    }

    checkVisibility(el: HTMLInputElement) {
        if (el.checkVisibility)
            return el.checkVisibility()
        else {
            // Traverse up the DOM
            let newEl: HTMLElement | null = el
            while (newEl) {
                // Get computed style of the current element
                const style = getComputedStyle(newEl)
                
                // Check for visibility conditions
                if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
                    return false
                }

                // Move to the parent element
                newEl = newEl.parentElement as HTMLElement | null
            }

            return true
        }
    }
}

// Instantiation based on the HTML element with the `data-modal-trigger` attribute
document.querySelectorAll('[simple-validate]').forEach(triggerElement => {
    SimpleValidate.getInstance(triggerElement as HTMLFormElement);
})
